<template>
    <van-popup @click-overlay="closePopup" v-model:show="show" position="center"
        :style="{ height: '80%', zIndex: '10002' }" class="gamePopContainer">
        <van-row class="popHeader">
            <van-col span="20" offset="2" class="Poptitle">{{ $t('home.allGames') }}</van-col>
            <van-col span="2"><van-icon name="cross" size="16" @click="closePopup" /></van-col>
        </van-row>

        <div class="searchField">
            <van-field v-model="localValue" type="text" :placeholder="$t('home.searchGames')" class="custom-field">
                <template #left-icon>
                    <div class="left-section">
                        <img src="@/assets/themetwo/icon_search.png" alt="">
                    </div>
                </template>
            </van-field>
        </div>
        <div class="gameContainer">
            <van-row class="game_container">
                <van-col span="24" class="right_container">
                    <van-row>
                        <van-col span="6" class="game_item" v-for="(item, index) in gameSet?.gameList" :key="index">
                            <GameCard :gameImage="item.customIcon"
                                @clickGameCard="GoToPlayGame(item.gameId, item.gameMakerId)" :gameTypeId="item.id"
                                :gameIsFavorite="item.isFavorite" />
                        </van-col>
                    </van-row>
                    <div v-if="gameSet?.gameList.length > 0" class="gameProgressBar">
                        <div class="bar">
                            <div class="progress"
                                :style="{ width: gameSet?.gameList.length / gameSet.gameCount < 1 ? gameSet?.gameList.length * 100 / gameSet.gameCount + '%' : '100%' }">
                            </div>
                            <div class="progress-end-dot"
                                :style="{ left: `calc(${gameSet?.gameList.length * 100 / gameSet.gameCount}% - 6px)` }">
                            </div>
                        </div>
                        <div style="margin-left: 10px;">
                            {{ Math.round(gameSet?.gameList.length / gameSet.gameCount * 100) }}%
                        </div>
                    </div>
                    <div v-if="!gameSet?.loading && gameSet?.showLoadMore" class="load_more_btn" @click="loadMoreGame">
                        {{ $t('common.loadMore') }}
                        <img src="@/assets/common/loadMore.png" alt="">
                    </div>
                    <div v-if="gameSet?.loading" class="loading_btn">
                        <van-loading size="20" />
                        {{ $t('common.loading') }}
                    </div>
                </van-col>
            </van-row>
        </div>
    </van-popup>
</template>
<script lang="ts" setup>
import { ref, defineExpose, computed, watch, defineEmits, inject } from 'vue';
import GameCard from '../../game/components/gameCard.vue';
import { debounce, fetchGameList, goToPlayGame } from '@/view/home/supportScript';
import { useRouter } from 'vue-router';
const PAGE_SIZE = 20
const router = useRouter()
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const show = ref(false)
const localValue = ref('')
const openPopup = () => {
    show.value = true;
    getGameList()
}

const gameList = ref<any>([])
const gameCount = ref(0)
const pageNum = ref(1)
const loading = ref(false)
const pageSize = ref(PAGE_SIZE)
const showLoadMore = ref(false)

const gameSet = computed(() => ({
    gameCount: gameCount.value,
    gameList: gameList.value,
    showLoadMore: showLoadMore.value,
    loading: loading.value
}))
const emits = defineEmits(['goToPlayGame'])
const closePopup = () => {
    show.value = false;
}

const loadMoreGame = () => {
    if (gameCount.value > pageNum.value * pageSize.value) {
        pageNum.value = pageNum.value + 1
        getGameList()
    }
}

const getGameList = async () => {
    loading.value = true

    const { rows, total } = await fetchGameList(pageNum.value, pageSize.value, localValue.value)

    loading.value = false
    gameList.value = [...gameList.value, ...rows]
    gameCount.value = total
    showLoadMore.value = total > pageNum.value * pageSize.value
}
const GoToPlayGame = (id: any, makerId: any) => {
    goToPlayGame(router, openRegisterLoginPopup, id, makerId)
}
const resetList = () => {
    pageNum.value = 1;
    gameList.value = [];
};
const debouncedSearch = debounce(() => {
    resetList()
    getGameList()
}, 500)

watch(localValue, () => {
    debouncedSearch()
})
defineExpose({
    openPopup
})
</script>
<style scoped>
.gamePopContainer {
    width: 80%;
    border-radius: 15px;
    background-color: #30241ce8;
}

.gamePopContainer::-webkit-scrollbar {
    display: none;
}

.van-overlay {
    z-index: 10001 !important;
    backdrop-filter: blur(5px);
}

.popHeader {
    background: linear-gradient(90deg, #e3af57 0, #4f341c);
    color: #fff;
    padding: 15px;
}

.Poptitle {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
}

.searchField {
    padding: 15px;
}

.left-section {
    display: flex;
    align-items: center;
}

.left-section img {
    width: 25px;
    padding: 0 10px;
}

.searchField>>>.van-cell {
    padding: 10px 5px;
    font-size: 14px;
    align-items: center;
    background: #281010;
    border: 1px solid #b68e5d6e;
    border-radius: 10px;
}

.searchField>>>.van-field__control {
    font-size: 14px;
    font-weight: bold;
    color: #fff;
}

.searchField ::v-deep(.van-field__control::placeholder) {
    color: #ece2d653 !important;
    font-size: 14px !important;
    font-weight: 400;
    display: flex;
    align-items: center;
}

.gameContainer {
    padding: 0 5px;
    border-radius: 10px;
    height: 75%;
    overflow: hidden;
    overflow-y: auto;
    background: #281010;
    margin: 0 15px;
}

.gameContainer::-webkit-scrollbar {
    display: none;
}

.game_container {
    flex: 1;
    display: flex;
    height: 100%;
    overflow: hidden;
}

.right_container {
    padding-right: 10px;
    height: 100%;
    overflow-y: auto;
}

.right_container {
    height: 100%;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding-bottom: 20px;
}

.right_container::-webkit-scrollbar {
    display: none;
}

.game_item {
    padding: 5px;
}

.load_more_btn {
    font-size: 15px;
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.65);
    border-radius: 20px;
    padding: 10px 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: 10px 65px;

}

.load_more_btn img {
    width: 15px;
    height: 15px;
    opacity: 0.5;
    margin-left: 10px;
}

.loading_btn {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 25px;
    margin: 5px 65px;

}

.gameProgressBar {
    display: flex;
    align-items: center;
    margin: 5px 30%;
    color: #fff;
}

.bar {
    position: relative;
    background: rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    height: 8px;
    width: 100%;
    margin: 10px 0;
}

.progress {
    background: #F0A853;
    border-radius: 10px;
    height: 8px;
}

.progress-end-dot {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    background-color: white;
    border-radius: 50%;z-index: 2;
}
</style>